export const NOCARD = {
  NO_WAY: "لا توجد وسيلة استلام",
  ADD_BANK:
    "ﻗﻢ ﺑﺈﺿﺎﻓﺔ معلومات حسابك البنكي، لتتمكن ﻣﻦ اﺳﺘﻠﺎم  اﻟﺄﻣﻮال ﺧﻠﺎل وﻓّﻲ",
};

export const BUTTON = {
  ADD_ACCOUNT: "إضافة حساب بنكي",
};
